<div>
  <div class="d-flex align-items-end flex-column justify-content-end w-100">
    @if (config?.view) {
      <button
        matTooltip="Guardar"
        matTooltipPosition="above"
        mat-mini-fab
        color="warn"
        (click)="openDialogFunction()"
        [style.visibility]="
          config.itemsData[config.itemsData.length - 1]?.itemInventoryId
            ? 'visible'
            : 'hidden'
        "
        >
        <mat-icon>save</mat-icon>
      </button>
    }
    @if (config?.showReplyButton) {
      <button
        matTooltip="Regresar"
        class="mt-1"
        mat-mini-fab
        color="primary"
        (click)="replyRouteNavigate()"
        >
        <mat-icon>reply</mat-icon>
      </button>
    }
    @if (config?.showPrintButton && config?.editHistoryInventory?.id) {
      <button
        mat-mini-fab
        color="accent"
        type="button"
        (click)="print()"
        style="margin-top: 10px"
        >
        <mat-icon>print</mat-icon>
      </button>
    }
  </div>
  <div
    class="firs-row mt-0 d-flex flex-column flex-md-row d-flex align-items-center justify-content-space-evenly col-12 p-0"
    >
    <div class="col-12 col-md-6">
      @if (!config?.fromPackOff && config?.addWarehouse) {
        <combos
          class="col-12 col-md-6 p-0"
          [configuration]="comboConfigWarehouse"
          [required]="true"
          [filter]="true"
          [reloadCombo]="reloadComboWarehouse"
          (changeOptionDataComplete)="valueWarehouse($event)"
          (returnDataCombo)="dataComboWarehouse($event)"
          [dataCombos]="null"
          [disabled]="!config.view || hasOneWarehouse"
          >
        </combos>
      }
      @if (config?.showTargetWarehouse) {
        <combos
          class="col-12 col-md-6 p-0"
          [configuration]="comboConfigTargetWarehouse"
          [required]="true"
          [filter]="true"
          [reloadCombo]="reloadComboTargetWarehouse"
          (changeOptionDataComplete)="valueTargetWarehouse($event)"
          (returnDataCombo)="dataComboTargetWarehouse($event)"
          [dataCombos]="null"
          [disabled]="!config.view || hasOneDestinationWarehouse"
          >
        </combos>
      }
      @if (config?.showProvider && config?.addProvider && config?.warehouseId > 0) {
        <combos
          class="col-12 col-md-6 p-0"
          [configuration]="comboConfigProvider"
          [reloadCombo]="reloadComboProvider"
          [required]="false"
          [filter]="true"
          (changeOption)="valueProvider($event)"
          (returnDataCombo)="dataComboProvider($event)"
          [disabled]="!config.view"
          >
        </combos>
      }
      @if (config?.showPurchaseOrder && config?.comboPurchaseOrder && config?.providerId > 0) {
        <combos
          class="col-12 col-md-6 p-0"
          [configuration]="comboConfigPurchaseOrderByState"
          [reloadCombo]="reloadComboPurchaseOrderByState"
          [filter]="true"
          [addFinal]="false"
          [additionalData]="firstInRow"
          (changeOption)="changesComboPurchaseOrder($event)"
          (returnDataCombo)="dataComboPurchaseOrder($event)"
          >
        </combos>
      }
      @if (config?.comboWorkOrder && (config?.fromPackOff ? true : config?.warehouseId > 0)) {
        <combos
          [disabled]="config.workOrderState == 3"
          class="col-12 col-md-6 p-0"
          [configuration]="comboConfigWorkOrderByState"
          [reloadCombo]="reloadComboWorkOrderByState"
          [filter]="true"
          [addFinal]="false"
          [additionalData]="firstInRow"
          (changeOption)="changesComboWorkOrder($event)"
          >
        </combos>
      }
      @if (config?.addRentalOrder) {
        <combos
          class="col-12 col-md-6 p-0"
          [configuration]="comboConfigRentalOrder"
          [reloadCombo]="reloadComboRentalOrder"
          [filter]="true"
          (changeOptionDataComplete)="changesComboRentalOrder($event)"
          (returnDataCombo)="dataComboRentalOrder($event)"
          >
        </combos>
      }
    </div>
    <div class="col-6">
      @if (config?.showTotal) {
        <app-button-label
          class="text-center"
          [labels]="config.labels"
          [ngClass]="config.addProvider ? 'col-12 col-md-6' : 'col-12'"
          >
        </app-button-label>
      }
    </div>
  </div>
  <div class="default-row mb-3 mt-0">
    <div class="row-item col-6">
      @if (config?.addAuthorize) {
        <combos
          class="col-12 col-md-6"
          [configuration]="comboConfigUserAutorize"
          [required]="true"
          [filter]="true"
          (changeOption)="valueUser($event)"
          (returnDataCombo)="dataComboUser($event)"
          [disabled]="!config.view"
          >
        </combos>
      }
    </div>
    <div class="row-item col-6">
      @if (config?.addReceptionDate) {
        <mat-form-field [appOpenDatepickerOnClick]="pickerReception">
          <mat-label>Fecha recepción Tentativa</mat-label>
          <input
            matInput
            [ngModel]="config.receptionDate"
            (ngModelChange)="receptionDateChange.emit($event)"
            [matDatepicker]="pickerReception"
            autocomplete="off"
            required
            [disabled]="!config.view"
            />
          <mat-hint>MM/DD/YYYY</mat-hint>
          <mat-datepicker-toggle matIconSuffix [for]="pickerReception">
          </mat-datepicker-toggle>
          <mat-datepicker
            #pickerReception
            [touchUi]="config.isMobile ? false : true"
          ></mat-datepicker>
          <mat-error>Campo requerido</mat-error>
        </mat-form-field>
      }
    </div>
  </div>
</div>
